import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class Feuerrohbaurisiko extends AbstractRequirementMapper {
  protected frontendKey = 'rohbau.feuerRohbauRisiko';
}
